import React from "react";

const RenderButton = ({ label, onClick, className, value, width = "110",disabled=false }) => {
  return (
    <button
      style={{ width: { width }, maxHeight: 50 }}
      type="button"
      disabled={disabled}
      onClick={onClick}
      value={value}
      className={className}
    >
      {label}
    </button>
  );
};

export default RenderButton;
